import { useEffect, useState } from 'react';

const computeTouchpoint = () => {
  if (typeof window === 'undefined') return 'desktop';
  const isMobile =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(max-width: 768px)').matches;
  return isMobile ? 'mobile' : 'desktop';
};

export function useTouchpoint() {
  const [touchpoint, setTouchpoint] = useState(() => computeTouchpoint());

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    )
      return;

    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const onChange = () => setTouchpoint(computeTouchpoint());

    // Prefer the standard EventTarget API
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', onChange);
      return () => mediaQuery.removeEventListener('change', onChange);
    }

    // The addListener/removeListener API is deprecated and can be omitted,
    // since all modern browsers support addEventListener.
    // If you still want to support legacy browsers, you may keep the fallback,
    // but it's generally safe to remove.

    // If you want strict deprecation fix, just do nothing for legacy.
    return undefined;
  }, []);

  return touchpoint;
}
